namespace GeniuzPOS.InitialData {
    export enum IcWhsGenEnumWhsType {
        WhsType1 = 1,
        WhsType2 = 2,
        WhsType3 = 3
    }
    Serenity.Decorators.registerEnumType(IcWhsGenEnumWhsType, 'GeniuzPOS.InitialData.IcWhsGenEnumWhsType');
}
